// Services
import { HttpService } from "@mgs/ci2019-common/src/services/HttpService";

// Store
import { Store } from "#/store";

// Model
import { DashboardTile } from "@mgs/ci2019-common/src/interfaces/DashboardTile";

export class DashboardService {
  private static _instance;

  public static get instance() {
    if (!this._instance) {
      this._instance = new DashboardService();
    }
    return this._instance;
  }

  private constructor() {}

  private readonly http: HttpService = HttpService.instance;

  public async getTiles(
    portalId: Number,
    ids: number[] = [],
    isInEditMode: boolean
  ): Promise<Array<DashboardTile>> {
    let queryUrl = `${Store.instance.ui.appApiUrl}${portalId}/kacheln`;

    let params = {};
    if (ids.length > 0) {
      params["ids"] = ids;
    }

    if (isInEditMode) {
      params["no_cache"] = 1;
      params["mode"] = "edit";
    }

    const response = await this.http.get<Array<DashboardTile>>(queryUrl, {
      params: params,
    });

    return response.body!;
  }

  public async getFavorites(): Promise<Array<DashboardTile>> {
    let queryUrl = `${Store.instance.ui.appApiUrl}27/kacheln`;

    const response = await this.http.get<Array<DashboardTile>>(queryUrl, {
      params: {
        favorites: 1,
      },
    });

    return response.body!;
  }

  public async addFavorite(tileId) {
    let url = `${Store.instance.ui.appApiUrl}favorites`;
    const response = await this.http.post<any>(url, {
      cms_page_id: tileId,
    });

    return response.body!;
  }

  public async removeFavorite(tileId) {
    let url = `${Store.instance.ui.appApiUrl}favorites`;
    const response = await this.http.delete<any>(url + `/${tileId}`);

    return response.body!;
  }
}
